<template>
  <div class="form-group">
    <div style="width:100%" class="d-flex">
      <label :style="survey.id == 552 ? 'color: #12b' : {color: black}" class="title-bold mr-2" for="nome">{{questionText}} <span v-if="mandatoryQuestion === false">(Opcional)</span></label>
    </div>
    <p
			:style="
				template.style.surveyBgColor
					? { color: template.style.secondColor }
					: { color: black }
			"
			class="observation"
		>
			{{ questionObs }}
		</p>
    <input
      type="text"
      class="form-control"
      :id="questionId === 143 ? 'cel' : 'nome'"
      :style="template.style.surveyBgColor ? {backgroundColor: template.style.surveyBgColor, color: template.style.surveyTextColor}: {color: template.style.surveyTextColor}" 
      :placeholder="getPlaceHolder"
      :inputmode="documentInputMode"
      v-mask="inputMask"
      v-model="qtAnwser"
      v-on:keyup.enter="enterKey"
      v-on:keyup="allKeys"
    />
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import {
  getDocumentRule,
  sanitizeDocumentValue
} from "./documentRules";
export default {
  name: "Survey-Question-Text",
  data: () => ({
    qtAnwser: "",
    dataOk: false
  }),
  directives: {
    mask,
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  computed: {
    getPlaceHolder() {
      if (this.documentRule) return this.documentRule.placeholder;
      if (this.placeHolder) return this.placeHolder;
      return this.$t('type_answer_here');
    },
    documentRule() {
      return getDocumentRule(this.questionId);
    },
    inputMask() {
      return this.documentRule ? this.documentRule.mask : null;
    },
    documentInputMode() {
      if (!this.documentRule) return null;
      return this.documentRule.mask.includes("X") ? null : "numeric";
    },
    isPhoneQuestion(){
      if (this.questionId === 143) return '(##) #####-####'
      return null
    },
    survey() {
      return this.$store.state.template.survey;
    },
    template() {
      return this.$store.state.template;
    }
  },
  mounted: function() {
    /*
            if (this.$store.state.answers[this.questionId]) {
                if (this.$store.state.answers[this.questionId] != "") {
                    alert(this.$store.state.answers[this.questionId]);
                    this.qtAnwser = this.$store.state.answers[this.questionId];
                    alert(this.qtAnwser);
                }
            } */

    //this.setAnwser(this.questionId);

    this.qtAnwser = this.$store.getters.answerValue(this.questionId);

    this.focusInput();
        },
        watch: {
            qtAnwser() {
                this.allKeys();
            }
        },
  created() {},
  updated() {
    this.focusInput();
  },
  props: {
    questionText: { type: String },
    questionObs: { type: String, default: '' },
    questionId: { type: Number },
    placeHolder: { type: String },
    mandatoryQuestion: { type: Boolean }
  },
  methods: {
    focusInput() {
      this.$refs.fc.$el.focus();
    },
    normalizeAnswer(value) {
      return sanitizeDocumentValue(value, this.questionId);
    },
    allKeys() {
      if(this.qtAnwser == undefined)
        this.qtAnwser = "";
      this.qtAnwser = this.normalizeAnswer(this.qtAnwser);
      this.$emit("AnswerChanged", this.qtAnwser.trim(), this.questionId);
    },
    enterKey() {
      this.qtAnwser = this.normalizeAnswer(this.qtAnwser);
      this.$emit("QuestionAnwered", this.qtAnwser, this.questionId);
    }
  }
};
</script>


<style scoped>
.title-bold{
  font-family:'OxaniumBold';
  font-weight: 700;
  font-size: 1.25rem;
}
</style>
